import type { MonsterDef } from "../../engine/rpg/Monster";

export const MONSTERS: MonsterDef[] = [
  {
    id: "slime",
    name: "Slime",
    appearance: { kind: "slime", color: 0x49b3ff, accent: 0x1b3a6b, scale: 0.9 },
    stats: { maxHp: 8, maxMp: 0, attack: 8, defense: 3, agility: 4 },
    exp: 2,
    gold: [1, 4],
    description: "Hops. Wobbles. Occasionally bites.",
  },
  {
    id: "red-slime",
    name: "Ember Slime",
    appearance: { kind: "slime", color: 0xff6a4a, accent: 0x6b1b1b, scale: 0.95 },
    stats: { maxHp: 14, maxMp: 4, attack: 12, defense: 5, agility: 6 },
    exp: 5,
    gold: [3, 8],
    skills: [{ skill: "monster-flame", chance: 0.25 }],
  },
  {
    id: "bat",
    name: "Cave Bat",
    appearance: { kind: "bat", color: 0x6b4a8a, accent: 0x3a2450, scale: 0.85 },
    stats: { maxHp: 11, maxMp: 0, attack: 11, defense: 4, agility: 14, evasion: 0.12 },
    exp: 4,
    gold: [2, 6],
    cowardice: 0.3,
  },
  {
    id: "wolf",
    name: "Moor Wolf",
    appearance: { kind: "wolf", color: 0x8a7a6a, accent: 0x4a4038, scale: 1.0 },
    stats: { maxHp: 20, maxMp: 0, attack: 17, defense: 7, agility: 12 },
    exp: 8,
    gold: [5, 12],
    skills: [{ skill: "monster-bite", chance: 0.3 }],
  },
  {
    id: "plant",
    name: "Man-Eater",
    appearance: { kind: "plant", color: 0xd04a7a, accent: 0xffd23f, scale: 1.05 },
    stats: { maxHp: 26, maxMp: 0, attack: 19, defense: 12, agility: 5 },
    exp: 11,
    gold: [8, 16],
    skills: [{ skill: "monster-bite", chance: 0.35 }],
  },
  {
    id: "skeleton",
    name: "Rattlebones",
    appearance: { kind: "skeleton", color: 0xe8e2d0, accent: 0xb0b8c4, scale: 1.0 },
    stats: { maxHp: 24, maxMp: 6, attack: 21, defense: 10, agility: 9 },
    exp: 13,
    gold: [10, 20],
    skills: [{ skill: "monster-mend", chance: 0.4, whenHpBelow: 0.4 }],
  },
  {
    id: "ghost",
    name: "Pale Wisp",
    appearance: { kind: "ghost", color: 0xa8e0ff, accent: 0x2f6fd0, scale: 1.0 },
    stats: { maxHp: 22, maxMp: 12, attack: 15, defense: 6, agility: 16, evasion: 0.18 },
    exp: 15,
    gold: [12, 24],
    skills: [{ skill: "monster-drain", chance: 0.35 }],
  },
  {
    id: "golem",
    name: "Stone Sentinel",
    appearance: { kind: "golem", color: 0x7a7a86, accent: 0x66e0ff, scale: 1.05 },
    stats: { maxHp: 46, maxMp: 0, attack: 26, defense: 22, agility: 4 },
    exp: 26,
    gold: [24, 40],
  },
  {
    id: "knight",
    name: "Fallen Knight",
    appearance: { kind: "knight", color: 0x4a5a7a, accent: 0xffd23f, scale: 1.05 },
    stats: { maxHp: 40, maxMp: 8, attack: 30, defense: 18, agility: 13 },
    exp: 30,
    gold: [30, 50],
    skills: [{ skill: "monster-bite", chance: 0.2 }],
  },
  {
    id: "dragon",
    name: "Dragonlord's Whelp",
    appearance: { kind: "dragon", color: 0x2f7a4a, accent: 0xd8e05a, scale: 1.15 },
    stats: { maxHp: 90, maxMp: 20, attack: 38, defense: 24, agility: 15 },
    exp: 120,
    gold: [200, 260],
    skills: [
      { skill: "monster-flame", chance: 0.4 },
      { skill: "monster-bite", chance: 0.3 },
    ],
    description: "It has been waiting a long time.",
  },
];
